// removed by extract-text-webpack-plugin
module.exports = {"unsplashCreditBadge":"src-components-UnsplashCreditBadge----UnsplashCreditBadge-module---unsplashCreditBadge---2mVMc"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UnsplashCreditBadge/UnsplashCreditBadge.module.scss
// module id = 272
// module chunks = 221374088121123